export default __webpack_public_path__ + "static/media/STEMadium_WebInstructions_3.0de6699a.png";